import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import {Links} from '@/libs/constants/common.constants';
import MobileMenuWrapper from '@/components/layout/headers/MobileMenuWrapper';

export default function MobileMenu({ home, socialLinks }) {
  const t = useTranslations('header');
  
  const navItems = [
    { name: 'home', path: '/' },
    { name: 'catalog', path: '/catalog' },
    { name: 'blog', path: '/blog' },
    { name: 'faq', path: '/faq' },
    { name: 'contact', path: '/contact' },
    { name: 'tornado', path: Links.main },
  ];
  return (
      <MobileMenuWrapper id="menu" home={home} socialLinks={socialLinks}>
        <div className="ltn__utilize-menu">
          <ul>
            {navItems.map(({name, path, accordionItems}, idx) => (
                <li key={idx}>
                  {path ? (<Link href={path}>{t(`navbar.${name}`)}</Link>) : <span className="linkable">{t(`navbar.${name}`)}</span>}
                  {accordionItems ? (
                      <ul className="sub-menu">
                        {accordionItems?.map(({name: name1, path: path1, label}, idx1) => (
                            <li key={idx1}>
                              <Link href={path1}>
                                {t(`navbar.${name1}`)}
                              </Link>
                            </li>
                        ))
                        }
                      </ul>
                  ) : ('')}
                </li>
            ))}
          </ul>
        </div>
      </MobileMenuWrapper>
  );
};
